import { useEffect, useState } from "react";
import { CalendarCheck, Calculator, Phone } from "lucide-react";
import { useLang } from "@/lib/i18n";

export const MobileCtaBar = ({ onNavigate }) => {
  const { t } = useLang();
  const [visible, setVisible] = useState(false);
  const [inTarget, setInTarget] = useState(false);

  useEffect(() => {
    const targets = ["quote", "book"].map((id) => document.getElementById(id)).filter(Boolean);
    const seen = new Set();
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => (e.isIntersecting ? seen.add(e.target) : seen.delete(e.target)));
        setInTarget(seen.size > 0);
      },
      { threshold: 0.05 }
    );
    targets.forEach((el) => io.observe(el));
    return () => io.disconnect();
  }, []);

  useEffect(() => {
    const onScroll = () => {
      const nearBottom = window.innerHeight + window.scrollY > document.body.scrollHeight - 160;
      setVisible(window.scrollY > 320 && !nearBottom);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const show = visible && !inTarget;

  return (
    <div
      className={`sm:hidden fixed inset-x-0 bottom-0 z-40 px-3 pb-[max(0.75rem,env(safe-area-inset-bottom))] transition-[transform,opacity] duration-300 ${
        show ? "translate-y-0 opacity-100" : "translate-y-full opacity-0 pointer-events-none"
      }`}
      data-testid="mobile-cta-bar"
    >
      <div className="flex items-stretch gap-2 rounded-2xl bg-[#0E1A2B]/95 backdrop-blur-md border border-white/10 shadow-2xl p-2">
        <button
          onClick={() => onNavigate("quote")}
          className="flex-1 inline-flex items-center justify-center gap-2 rounded-xl bg-[#F26522] active:bg-[#D85312] text-white font-display font-bold text-sm py-3 transition-colors duration-200"
          data-testid="mobile-cta-quote-btn"
        >
          <Calculator className="h-4 w-4" /> {t("nav_cta")}
        </button>
        <button
          onClick={() => onNavigate("book")}
          className="flex-1 inline-flex items-center justify-center gap-2 rounded-xl border border-white/20 text-white font-display font-bold text-sm py-3 active:bg-white/10 transition-colors duration-200"
          data-testid="mobile-cta-book-btn"
        >
          <CalendarCheck className="h-4 w-4" /> {t("nav_book")}
        </button>
        <a
          href="tel:3608617655"
          aria-label="Call 360-861-7655"
          className="inline-flex w-12 items-center justify-center rounded-xl border border-white/20 text-[#F26522] active:bg-white/10 transition-colors duration-200"
          data-testid="mobile-cta-phone-link"
        >
          <Phone className="h-5 w-5" />
        </a>
      </div>
    </div>
  );
};
